import { baseURL } from 'settings';

import { api as apiService, ApiService } from './api'
import { PaginationProps } from 'interfaces/IPagination';
import { ITransshipPoint } from 'interfaces/IWaybill';

interface ITransshipPointsParams {
  page?: number;
  pageSize?: number;
  orderBy?: string;
  name?: string;
  agileCode?: string;
  agileId?: string;
  city?: string;
  search?: string;
  inUse?: number;
  initials?: string;
  physicalTransshipPointId?: number;
}

class TransshipPointsService {
  constructor(private readonly api: ApiService, private readonly baseURL: string) {}

  public getTransshipPoints = (params: ITransshipPointsParams): Promise<PaginationProps<ITransshipPoint>> => {
    return this.api.get(`${this.baseURL}/v1/delivery/transship-point`, {params})
  }
}

export const transshipPointsService = new TransshipPointsService(apiService, baseURL)
